//import axios from 'axios'
import api from './axiosConfig'

export const suspectedFailureApi = {

    searchSuspectedFailures({ startDate, endDate, fwVersion, failureEffectId, emptyFailureMode, searchFilter, page, perPage} = {}) {

        const apiParams = {
            StartDate: startDate,
            EndDate: endDate,
            FWVersion: fwVersion,
            FailureEffectId: failureEffectId,
            EmptyFailureMode: emptyFailureMode,
            SearchFilter: searchFilter,
            Page: page,
            PerPage: perPage,
        };
        
        return api
            .get('/SuspectedFailure/search', {params: apiParams})
            .then((response) => {
                return response.data
            })
    },

    getSuspectedFailure({ id } = {}) {

        return api
            .get(`/SuspectedFailure?id=${id}`)
            .then((response) => {
                return response.data
            })
    },
    getSuspectedFailureModes() {

        return api
            .get(`/SuspectedFailure/Get/FailureMode`)
            .then((response) => {
                return response.data
            })
    },
    getSuspectedFailureOrigin() {

        return api
            .get(`/SuspectedFailure/Get/FailureOrigin`)
            .then((response) => {
                return response.data
            })
    },
    getSuspectedFailureEffects() {

        return api
            .get(`/SuspectedFailure/Get/FailureEffect`)
            .then((response) => {
                return response.data
            })
    },
    fetchRecentSuspectedFailureSummary({ startDate, endDate } = {}) {
        const apiParams = {
            StartDate: startDate,
            EndDate: endDate,
        };

        return api
            .get(`/SuspectedFailure/RecentSuspectedFailureSummary`, { params: apiParams })
            .then((response) => {
                return response.data
            })
    },
    updateSuspectedFailure({ id, failureModeId, note, fwVersion, intelId, obdId } = {}) {
        return api
            .put('/SuspectedFailure/update', { id, failureModeId, note, fwVersion, intelId, obdId }, {})
            .then((response) => {
                return response.data
            })
    },

}
